import React from "react";
import { Heart } from "lucide-react";

/**
 * Sticky CTA bar for Lot pages
 * Shows lot info and primary actions (wishlist + request samples)
 * Replaces generic mobile CTA on Lot pages
 */
const LotStickyCTA = ({ lot, typeName, isWishlisted, onToggleWishlist, onRequestSamples }) => {
  return (
    <div
      data-testid="lot-sticky-cta"
      className="fixed bottom-0 left-0 right-0 z-40 bg-brand-charcoal/95 backdrop-blur-md border-t border-brand-gold/20"
    >
      <div className="editorial-container py-3 md:py-4">
        <div className="flex items-center justify-between gap-4">
          {/* Left: Lot Info (hidden on small mobile) */}
          <div className="hidden sm:block">
            <p className="font-sans text-sm md:text-base text-brand-cream">
              <span className="font-medium">Lot #{lot.id}</span>
              <span className="text-brand-cream/50 mx-2">·</span>
              <span className="text-brand-cream/75">{typeName}</span>
            </p>
          </div>

          {/* Right: Action Buttons */}
          <div className="flex items-center gap-2 md:gap-3 w-full sm:w-auto">
            {/* Wishlist Button */}
            <button
              type="button"
              onClick={onToggleWishlist}
              data-testid="lot-sticky-wishlist-btn"
              aria-label={isWishlisted ? "Remove from wishlist" : "Add to wishlist"}
              aria-pressed={isWishlisted}
              className={`flex-1 sm:flex-none inline-flex items-center justify-center gap-2 px-4 md:px-5 py-2.5 md:py-3 font-sans text-xs md:text-sm uppercase tracking-[0.2em] transition-all duration-300 border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold ${
                isWishlisted
                  ? "bg-brand-gold/10 text-brand-gold border-brand-gold/40 hover:bg-brand-gold/15"
                  : "bg-transparent text-brand-gold border-brand-gold/40 hover:bg-brand-gold/5 hover:border-brand-gold/60"
              }`}
              style={{ borderRadius: "5px" }}
            >
              <Heart
                className={`w-4 h-4 ${isWishlisted ? "fill-current" : ""}`}
                aria-hidden="true"
              />
              <span className="hidden sm:inline">
                {isWishlisted ? "Saved" : "Save"}
              </span>
            </button>

            {/* Request Samples Button */}
            <button
              type="button"
              onClick={onRequestSamples}
              data-testid="lot-sticky-request-btn"
              aria-label="Request free samples for this lot"
              className="flex-1 sm:flex-none inline-flex items-center justify-center px-5 md:px-6 py-2.5 md:py-3 bg-brand-gold text-brand-charcoal font-sans text-xs md:text-sm font-medium uppercase tracking-[0.2em] transition-all duration-300 hover:bg-brand-gold/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold"
              style={{ borderRadius: "5px" }}
            >
              Request Free Samples
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LotStickyCTA;
